import React, {useState} from 'react'

const RolnePreview = ({rolne}: {rolne?: string | null}) => {
  const [expanded, setExpanded] = useState(false)
  const rolls = (rolne ?? '')
    .split(',')
    .map((roll) => roll.trim())
    .filter(Boolean)
  const text = rolls.join(',')
  if (!text) return null
  const canExpand = text.length > 11

  return (
    <div className='mt-1' style={{width: '14ch', maxWidth: '100%'}}>
      <div
        className='badge badge-success d-block text-start'
        style={{whiteSpace: 'normal', overflowWrap: 'anywhere'}}
      >
        {expanded
          ? rolls.map((roll, index) => (
              <span key={index} className='d-block'>
                {roll}
              </span>
            ))
          : `${text.slice(0, 11)}${canExpand ? '…' : ''}`}
      </div>
      {canExpand && (
        <button
          type='button'
          className={`btn btn-link ${expanded ? '' : 'text-danger'} p-0 mt-1 fs-8`}
          style={expanded ? {color: '#fd7e14'} : undefined}
          aria-expanded={expanded}
          onClick={() => setExpanded((value) => !value)}
        >
          {expanded ? 'Vidi manje' : 'Vidi više'}
        </button>
      )}
    </div>
  )
}

export default RolnePreview
